import { useMemo } from "react";
import { useQuery } from "react-query";
import { useOkapiKy } from "@folio/stripes/core";
import { fetchAllPublisherPrefixes } from "../api/publisherPrefixService";
import { getPendingDeclarationPrefixes } from "../utils/pendingDeclaration";
/** Query key prefix — shares the "publisher-prefixes" namespace so declaring invalidates it. */
export var PENDING_DECLARATION_QUERY_KEY = "publisher-prefixes";
var escapeCql = function (input) { return input.replace(/(["\\])/g, "\\$1"); };
/**
 * Loads the active publisher prefixes of a single publisher that still await a last-used-number
 * declaration (declarationStatus === PENDING), optionally narrowed to one registration agency.
 *
 * The feasibility answer for a title reports the agency and that a declaration is pending, but not
 * which prefix — so the create dialog and the module entry gate both resolve the concrete PENDING
 * prefix(es) here from the publisher-scoped list. The query lives under the shared
 * "publisher-prefixes" key, so a successful declaration (which invalidates that key) refetches it and
 * the pending block/gate disappears once the backend clears the status.
 */
export var usePendingDeclarationPrefixes = function (_a) {
    var publisherSourceId = _a.publisherSourceId, agency = _a.agency, _b = _a.enabled, enabled = _b === void 0 ? true : _b;
    var ky = useOkapiKy();
    var isEnabled = enabled && !!publisherSourceId;
    var _c = useQuery([PENDING_DECLARATION_QUERY_KEY, "pendingDeclaration", publisherSourceId], function () {
        return fetchAllPublisherPrefixes(ky, "publisher.sourceId==\"".concat(escapeCql(publisherSourceId), "\" and status==\"ACTIVE\""));
    }, { enabled: isEnabled }), data = _c.data, isLoading = _c.isLoading;
    var pendingPrefixes = useMemo(function () { return getPendingDeclarationPrefixes(data === null || data === void 0 ? void 0 : data.items, agency); }, [data, agency]);
    return { pendingPrefixes: pendingPrefixes, isLoading: isEnabled ? isLoading : false };
};
